/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/order */

import { useState, useEffect } from 'react';
import { TabsBM } from 'src/components/@material-extend/TabsBM';
import { ButtonBm, CircularProgessBm, TypographyBm } from 'src/components/@material-extend';
import { Header } from '../../layouts/questionnaire/Header';
import { ConserationRanch } from '../../layouts/questionnaire/ConserationRanch';
import { LiveStockRanch } from '../../layouts/questionnaire/LiveStockRanch';
import { ManagementRanch } from '../../layouts/questionnaire/ManagementRanch';
import { OptionalRanch } from '../../layouts/questionnaire/OptionalRanch';
import { RegPractices } from '../../layouts/questionnaire/regPractices';
import { Validation } from 'src/layouts/questionnaire/validation';
import { useLocation, useNavigate } from 'react-router-dom';
import { ranchApi } from 'src/components/api';
import { useSnakBarTran } from 'src/hook';
import { Stack, Box } from '@mui/material';
import CloudDoneIcon from '@mui/icons-material/CloudDone';

export const RanchInfo = () => {
  const { state } = useLocation();
  const {
    ranchInfo = {},
    otherDetails = {},
    partnerId = '',
    producerId = '',
    fieldId = ''
  } = state || {};

  const navigate = useNavigate();
  const { showSuccessSnackbar, showErrorSnackbar } = useSnakBarTran();

  const [optionalRanch, setOptionaRanch] = useState(ranchInfo.optionalRanch || {});
  const [managementRanch, setManagementRanch] = useState(ranchInfo.managementRanch || {});
  const [conserationRanch, setConserationRanch] = useState(ranchInfo.conserationRanch || {});
  const [liveStockRanch, setLiveStockRanch] = useState(ranchInfo.liveStockRanch || {});
  const [regPractices, setRegPractices] = useState(ranchInfo.regPractices || {});

  const [activeTab, setActiveTab] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [lastSaved, setLastSaved] = useState();
  const [questionStatus, setQuestionStatus] = useState('');
  const [change, setChange] = useState(0);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    if (change === 0) return;
    const timer = setTimeout(() => {
      saveDraft();
      setChange(0);
    }, 2000);
    return () => clearTimeout(timer);
  }, [change]);

  useEffect(() => {
    if (localStorage.ranchInfo && otherDetails?.questionnaireStatus === 'DRAFT') {
      const ranchInfoData = JSON.parse(localStorage.getItem('ranchInfo'));
      if (ranchInfoData.id === producerId) updateState(ranchInfoData);
    }
  }, []);

  useEffect(() => {
    if (otherDetails.questionnaireStatus !== 'DRAFT' || questionStatus === 'FINAL') {
      setDisabled(false);
    }
  }, [otherDetails?.questionnaireStatus, questionStatus]);

  const updateState = (data) => {
    setRegPractices(data.regPractices || {});
    setOptionaRanch(data.optionalRanch || {});
    setManagementRanch(data.managementRanch || {});
    setConserationRanch(data.conserationRanch || {});
    setLiveStockRanch(data.liveStockRanch || {});
    setActiveTab(data.activeTab || 0);
  };

  const saveData = () => {
    setChange(0);
    const res = Validation(
      { optionalRanch, managementRanch, conserationRanch, liveStockRanch, regPractices },
      setActiveTab
    );
    if (res.error) {
      alert(res.message);
      return;
    }
    uploadData(questionStatus);
  };

  const uploadData = async (status) => {
    const submissionStatus = status || 'DRAFT';

    const payload = {
      producerId,
      fieldId,
      partnerId: partnerId || otherDetails?.userDetail?.oldPartnerId,
      questionnaireStatus: submissionStatus,
      questionnaire: {
        cobRanch: ranchInfo?.cobRanch || {},
        regPractices,
        optionalRanch,
        managementRanch,
        conserationRanch,
        liveStockRanch,
        infoStatus: submissionStatus.toLowerCase()
      }
    };

    // Remove empty objects
    Object.keys(payload.questionnaire).forEach((key) => {
      if (
        typeof payload.questionnaire[key] === "object" &&
        Object.keys(payload.questionnaire[key]).length === 0
      ) {
        delete payload.questionnaire[key];
      }
    });

    try {
      setIsPending(true);
      await ranchApi.post('/submitQuestionnaire', payload);
      setIsPending(false);

      if (submissionStatus === 'FINAL') {
        showSuccessSnackbar({ text: 'Successfully submitted Questionnaire' });
      } else {
        showSuccessSnackbar({ text: 'Draft saved successfully' });
      }

      navigate(`../documents?TotalDoc=0`, {
        state: {
          fieldId,
          producerId,
          status: otherDetails?.status
        }
      });

    } catch (error) {
      setIsPending(false);
      showErrorSnackbar({
        text: error?.response?.data?.message || 'Failed to submit Questionnaire'
      });
    }
  };

  const saveDraft = () => {
    const date = new Date();
    localStorage.setItem(
      'ranchInfo',
      JSON.stringify({
        optionalRanch,
        managementRanch,
        conserationRanch,
        liveStockRanch,
        regPractices,
        activeTab,
        id: producerId,
        lastSaved: date.toString()
      })
    );
    setLastSaved(date);
  };

  const handleSkip = () => {
    setQuestionStatus('DRAFT');
    uploadData('DRAFT');
  };

  const handleSubmit = () => {
    setQuestionStatus('FINAL');
    saveData('FINAL');
  };

  return (
    <div style={{ padding: '2rem' }}>
      <Header
        actionButton
        time={lastSaved}
        details={otherDetails}
        loading={isPending}
        saveData={saveData}
        heading="Questionnaire"
        setQuestionStatus={setQuestionStatus}
      />

      {otherDetails.status !== 'CONFIRMED' && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Stack direction="row" alignItems="center" mr={2}>
            {isPending ? (
              <CircularProgessBm size={20} sx={{ color: '#004752' }} />
            ) : (
              lastSaved && <CloudDoneIcon sx={{ color: '#004752' }} />
            )}
            <TypographyBm sx={{ margin: '1rem 0.5rem' }}>
              {isPending ? 'Saving' : lastSaved && 'Draft saved'}
            </TypographyBm>
          </Stack>

          <ButtonBm
            onClick={handleSkip}
            sxExtra={{
              margin: '.5rem',
              backgroundColor: 'white',
              border: '1px solid rgba(29,29,31,0.3)',
              borderRadius: '20px',
              color: '#1D1D1F'
            }}
            variant="contained"
          >
            Skip for now
          </ButtonBm>

          {(!otherDetails.questionnaireStatus ||
            otherDetails.questionnaireStatus === 'DRAFT') && (
            <ButtonBm
              onClick={handleSubmit}
              sxExtra={{
                margin: '.5rem',
                backgroundColor: '#004752',
                borderRadius: '20px'
              }}
              variant="contained"
            >
              Submit
            </ButtonBm>
          )}
        </Box>
      )}

      <TabsBM
        value={activeTab}
        handleChange={(v) => setActiveTab(v)}
        fullWidth
        labelComponents={[
          {
            label: 'Regenerative Practices',
            Component: (
              <RegPractices
                value={regPractices}
                disabled={disabled}
                handelChange={(v) => {
                  setRegPractices(v);
                  setChange(change + 1);
                }}
              />
            )
          },
          {
            label: 'Livestock Type and Count',
            Component: (
              <LiveStockRanch
                disabled={disabled}
                value={liveStockRanch}
                handleChange={(v) => {
                  setLiveStockRanch(v);
                  setChange(change + 1);
                }}
              />
            )
          },
          {
            label: 'Management Practices',
            Component: (
              <ManagementRanch
                disabled={disabled}
                value={managementRanch}
                handleChange={(v) => {
                  setManagementRanch(v);
                  setChange(change + 1);
                }}
              />
            )
          },
          {
            label: 'Water Conservation',
            Component: (
              <ConserationRanch
                disabled={disabled}
                value={conserationRanch}
                handleChange={(v) => {
                  setConserationRanch(v);
                  setChange(change + 1);
                }}
              />
            )
          },
          {
            label: 'Optional Questions',
            Component: (
              <OptionalRanch
                disabled={disabled}
                value={optionalRanch}
                handleChange={(v) => {
                  setOptionaRanch(v);
                  setChange(change + 1);
                }}
              />
            )
          }
        ]}
      />
    </div>
  );
};
